import { Component, signal, OnInit, OnDestroy, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { I18nService } from '@app/core/i18n.service';
import { environment } from '@env/environment';
import { BaseAPIService } from '@app/Services/api.base.service';
import { label } from '@app/constants/labels';
import { rolesdef } from '@app/constants/role-def';
import { MapService } from '@app/map/map.service';
import { TermsComponent } from '@app/CustomControls/terms/terms.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  menuHidden = true;
  private loginSubscription: Subscription;

  public seLogo: string;

  public title: string;
  public subtitle: string;
  public user: any = {};
  public logo: string;
  public ecoLogo: string;
  public loginIcon: string;
  public dropIcon: string;
  public localeIcon: string;
  public language: string;

  public isLoggedIn: boolean = false;
  public isInternalUser: boolean = true; // default isInternalUser is true
  public loggedInUser: string | null;
  public urls: any = {};
  labels: any;
  roleCd: string;
  roles: any;
  showUserMenu: boolean = false;
  userMenuPosition: { top: number; left: number } = { top: 0, left: 0 };
  @ViewChild('userInfoRef', { static: false }) userInfoRef: ElementRef;
  // readonly theme = signal<'light' | 'dark'>('light');

  constructor(private readonly baseService: BaseAPIService, public router: Router,
    private readonly authenticationService: AuthenticationService,
    private i18nService: I18nService, private readonly modalService: NgbModal,
    private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (this.showUserMenu && !this.elementRef.nativeElement.querySelector('.user-info')?.contains(event.target)) {
      this.showUserMenu = false;
    }
  }

  ngOnInit() {
    this.labels = label;
    this.roles = rolesdef;
    this.dropIcon = 'assets/dropdown.svg';
    this.localeIcon = 'assets/countrySelection.svg';
    this.loginIcon = 'assets/login.svg';
    this.logo = 'assets/speedometer.svg';
    this.ecoLogo = 'assets/eco-cc-logo.png';
    this.seLogo = 'assets/schneiderLogo.png';
    this.title = environment.title;
    this.language = localStorage.getItem('language');

    // Subscribe to reactive login state so the header appears once login completes
    this.loginSubscription = this.authenticationService.userLoginIn$.subscribe(loggedIn => {
      this.isLoggedIn = loggedIn;
      if (loggedIn) {
        this.initAuthenticatedState();
      }
    });

    // Also check synchronously for already-authenticated sessions (e.g. page refresh)
    if (this.authenticationService.isAuthenticated()) {
      this.isLoggedIn = true;
      this.initAuthenticatedState();
    }
  }

  ngOnDestroy(): void {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }

  private initAuthenticatedState(): void {
    this.roleCd = this.authenticationService.authenticatedRoleCd;
    this.loggedInUser = this.authenticationService.authenticatedUser;
    this.isInternalUser = this.authenticationService.context && JSON.parse(JSON.stringify(this.authenticationService.context.idms)).isInternal !== null ? JSON.parse(JSON.stringify(this.authenticationService.context.idms)).isInternal.toLowerCase() === 'true' : false;
    this.urls = JSON.parse(this.authenticationService.urls);
  }

  // private applyTheme() {
  //   document.body.classList.toggle('qds-theme-dark', this.theme() === 'dark');
  //   document.body.classList.toggle('qds-theme-light', this.theme() === 'light');
  // }

  // toggleTheme() {
  //   this.theme.set(this.theme() === 'light' ? 'dark' : 'light');
  //   localStorage.setItem('theme', this.theme());
  //   this.applyTheme();
  // }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }

  toggleUserMenu() {
    this.showUserMenu = !this.showUserMenu;
    if (this.showUserMenu && this.userInfoRef) {
      const rect = this.userInfoRef.nativeElement.getBoundingClientRect();
      this.userMenuPosition = {
        top: rect.bottom + 4,
        left: rect.left
      };
    }
  }

  setLanguage(language: any) {
    this.i18nService.language = language.code;
  }

  logout() {
    this.authenticationService.logout();
  }

  navigateToUrl(url: string) {
    window.open(url + '&lang=' + this.language, '_self');
  }

  get currentLanguage(): string {

    const sslang = this.i18nService.supportedLanguages.filter(item => item.code === this.i18nService.language);
    return sslang[0].name;
  }

  get languages(): any[] {
    return this.i18nService.supportedLanguages;
  }

}
